import _ from 'lodash';
import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';
import Money from 'components/Money';

import {formatDate} from 'utils/datetime';

import './styles.css';

const OffersTable = ({offers, openCreateOfferModal, source}) => (
  <div className="OffersTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem className="startDate" heading="Start date" />
        <Table.HeaderItem className="endDate" heading="End date" />
        <Table.HeaderItem className="roomDeposit" heading="Room deposit" />
        <Table.HeaderItem className="rentPerWeek" heading="Rent per week" />
        <Table.HeaderItem className="createdBy" heading="Created by" />
        <Table.HeaderItem className="createdAt" heading="Date created" />
        <Table.HeaderItem
          className="breakClauseType"
          heading="Break Clause Type"
        />
        <Table.HeaderItem
          className="breakClausePeriod"
          heading="Break Clause Period"
        />
        <Table.HeaderItem
          className="breakClauseNoticePeriod"
          heading="Break Clause Notice Period"
        />
      </Table.Header>
      <Table.Body>
        {offers &&
          offers.map(offer => (
            <Table.Row key={offer.id}>
              <Table.Cell>{formatDate(offer.startDate)}</Table.Cell>
              <Table.Cell>{formatDate(offer.endDate)}</Table.Cell>
              <Table.Cell>
                <Money amount={offer.roomDeposit} />
              </Table.Cell>
              <Table.Cell>
                <Money amount={offer.pwRent} />
              </Table.Cell>
              <Table.Cell>
                {_.get(offer, 'createdBy.fullName') || source}
              </Table.Cell>
              <Table.Cell>{formatDate(offer.createdAt)}</Table.Cell>
              <Table.Cell>{offer.breakClauseType || '-'}</Table.Cell>
              <Table.Cell>{offer.breakClausePeriod || '-'}</Table.Cell>
              <Table.Cell>{offer.breakClauseNoticePeriod || '-'}</Table.Cell>
            </Table.Row>
          ))}
      </Table.Body>
    </Table>
    <div className="options">
      <Button blue className="newOffer" onClick={openCreateOfferModal}>
        New Offer
      </Button>
    </div>
  </div>
);

export default OffersTable;
